export default __webpack_public_path__ + "static/media/ladakh.7d13ccbd.jpg";